import { message } from 'antd';
import swal from 'sweetalert';
import { appNames } from '../../constants/appNames';
import { useEffect, useDispa } from 'react';
import { localStoreKeys } from "../../constants/localStoreKeys";
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import { useDispatch } from 'react-redux';
import { staticNotes } from '../../constants/staticNotes';
import showNotificationModal from '../Notification/NotificationModal.js';

/* istanbul ignore next */
const showChartDisplayError = () => {
        // swal({
        //     title: 'Data Unavailable',
        //     text: staticNotes.DATA_UNAVAILABLE_NOTE,
        //     icon: 'warning',
        //     button: "Go Back"
        // })
        //     .then(() => {
        //         console.log("chart is not accessible");

        //     })
        showNotificationModal({
            title: 'Data Unavailable',
            text: staticNotes.DATA_UNAVAILABLE_NOTE,
            icon: 'warning',
            button: "Go Back"
        })
        .then(() => {
            console.log("chart is not accessible");
        });
}

const vlaidateLandingPageFilters = (isSelectedFromSingleButton, landingPageFilters, setOpenModal, openModal, capability) => {
    // console.log("landingPageFilters", landingPageFilters);

    if (landingPageFilters?.sectors.length > 0 && landingPageFilters?.bus.length > 0 && landingPageFilters?.l0s.length > 0) {
        if (capability === appNames.coman && isSelectedFromSingleButton) {

            // setAppName("Global SPM")
            if (landingPageFilters.l1s.length > 0) {
                // dispatch(setKeyValue({ key: localStoreKeys.isModalOpened, value: true }))
                localStorage.setItem('isLSModalOpened', true)
                setOpenModal(true)
            } else {
                message.warning("Please Select the required L1 filters")
            }
        } else if (landingPageFilters.l1s.length > 0) {
            // dispatch(setKeyValue({ key: localStoreKeys.isModalOpened, value: true }))
            localStorage.setItem('isLSModalOpened', true)
            setOpenModal(true)
        } else {
            message.warning("Please Select the required L1 filters")
        }
    } else {
        message.warning("Please Select the required filters")
    }
}

function useAmesaFilteronCards(landingPageFilters, setDataIssueWarningText) {
    useEffect(() => {
        const sectorSelected = landingPageFilters?.sectors;
        const hasNonAMESA = sectorSelected.some(item => item.displayText !== "AMESA");
        const hasAMESA = sectorSelected.some(item => item.displayText === "AMESA");
        let appName = "Spend HQ";
        if (hasAMESA) {
            if (hasNonAMESA) {
                appName = "Spend HQ/AMESA PBI App";
            } else {
                appName = "AMESA PBI App";
            }
        }
        setDataIssueWarningText("Due to some updates in " + appName + ", numbers what you see here can differ slightly. This is expected to solve soon by app team");

    }, [landingPageFilters]);
}

function useButtonItemsArray(buttonGroupItems, setAppName, landingPageFilters, setOpenModal, openModal, capability) {
    return [
        { icon: "bar_chart", onClick: () => console.log("Bar chart clicked") },
        ...buttonGroupItems
            .filter((item) => item.label !== "AMESA Contract Analytics" && item.label !== "AMESA PBI App" 
            // && item.label !== "SAP Ariba (SSS)" // COMMENT THIS TO ENABLE SAP ARIBA
            && item.label !== "SAP Ariba (Standalone)" 
            && item.label !== "PSD Lite" && item.label !== "SAP Ariba CLM" 
            && item.label !== "Spendwise"  
            && !((item.label).includes("Cockpit")))
            .map((item) => ({
                ...item,
                label: item.label.replace(" (SSS)", "") + " - KPIs",
                disabled: !item.chartDisplay,
                onClick: () => {
                    if (item.chartDisplay) {
                        setAppName(item.label.replace(" (SSS)", ""));
                        vlaidateLandingPageFilters(false, landingPageFilters, setOpenModal, openModal, capability);
                    } else {
                        showChartDisplayError();
                    }

                },
            })),
    ];
}

export { showChartDisplayError, vlaidateLandingPageFilters, useAmesaFilteronCards, useButtonItemsArray }